/**
 * Fetch Facebook user profile using access token
 */
export async function fetchFacebookUserProfile(accessToken: string): Promise<{
  id: string;
  name: string;
  email?: string;
  picture?: {
    data: {
      url: string;
    };
  };
} | null> {
  try {
    const response = await fetch(
      `https://graph.facebook.com/v20.0/me?fields=id,name,email,picture&access_token=${accessToken}`
    );

    if (!response.ok) {
      console.error('Failed to fetch Facebook user profile:', response.status);
      return null;
    }

    return await response.json();
  } catch (error) {
    console.error('Error fetching Facebook user profile:', error);
    return null;
  }
}
